import React, { useState, useEffect } from "react";
import Slider from "rc-slider";

// import './PricingCalculator.css'; // You can style the component with this CSS file

const SettingBillingCalculator = () => {
  // States to store the values for triggers, industries, accounts, and billing type
  const [triggers, setTriggers] = useState(10);
  const [industries, setIndustries] = useState(10);
  const [accounts, setAccounts] = useState(10);
  const [billingType, setBillingType] = useState("monthly");
  const [totalPrice, setTotalPrice] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [isCustom, setIsCustom] = useState(false);

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (value === "custom") {
      setIsCustom(true);  
    } else {
      setSelectedOption(value);
      setIsCustom(false); 
    }
  };

  const handleCustomChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const marks = {
    3: "6",
    6: "9",
    9: "12",
    12: "15",
    15: "20",
    20: "25",
  };

  // Costs per unit
  const triggerCost = 20;
  const industryCost = 30;
  const accountCost = 40;

  // useEffect to calculate total price when triggers, industries, accounts, or billingType changes
  useEffect(() => {
    const calculateTotalPrice = () => {
      let totalCost =
        triggers * triggerCost +
        industries * industryCost +
        accounts * accountCost;

      if (billingType === "yearly") {
        totalCost = totalCost * 12; // Multiply by 12 for yearly billing
        totalCost = totalCost * 0.9; // Apply a 10% discount
      }

      setTotalPrice(totalCost.toFixed(2)); // Set the total cost and round it to two decimal places
    };

    calculateTotalPrice();
  }, [triggers, industries, accounts, billingType]); // Dependencies

  return (
    <div className="pricing-calculator !p-10 !gap-x-14">
      <div className="pricing-options">
        <div className="form-group !mb-16">
          <label className="text-lg !font-semibold">No. of Users</label>
          {isCustom ? (
        <input
          type="number"
          value={selectedOption}
          onChange={handleCustomChange}
          placeholder="Enter custom value"
          className="block w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:border-[var(--brand-primary)] transition duration-300 ease-in-out"
        />
      ) : (
        <select
        value={selectedOption}
        onChange={handleSelectChange}
        className="block w-full px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:border-[var(--brand-primary)] transition duration-300 ease-in-out hover:bg-gray-50"
      >
        <option value="" disabled className="text-gray-400">
          Select an option
        </option>
        <option value="1" className="text-gray-700">
           1
        </option>
        <option value="2" className="text-gray-700">
           2
        </option>
        <option value="3" className="text-gray-700">
           3
        </option>
        <option value="4" className="text-gray-700">
           4
        </option>
        <option value="5" className="text-gray-700">
           5
        </option>
        <option value="6" className="text-gray-700">
           6
        </option>
        <option value="custom" className="text-blue-500">
          Custom
        </option>
      </select>
      )}
        </div>

        <div className="form-group !mb-16">
          <label className="text-lg !font-semibold">Intelligent Triggers</label>
          <div className="mt-8">
            <Slider
              min={3}
              max={20}
              marks={marks}
              step={null}
              value={triggers}
              onChange={(newValue) => setTriggers(newValue)}
              trackStyle={{ height: 8 }} // Thickness of the track (filled part)
              railStyle={{ height: 8 }} // Thickness of the rail (unfilled part)
              handleStyle={{
                height: 24, // Height of the slider handle
                width: 24, // Width of the slider handle
                marginTop: -7, // Centers the handle with the track
                backgroundColor: "white", // Customize handle color
                borderColor: "var(--brand-primary)",
              }}
            />
          </div>
        </div>

        <div className="form-group !mb-16">
          <label className="text-lg !font-semibold">Target Industry</label>
          <div className="mt-8">
            <Slider
              min={3}
              max={20}
              marks={marks}
              step={null}
              value={industries}
              onChange={(newValue) => setIndustries(newValue)}
              trackStyle={{ height: 8 }} // Thickness of the track (filled part)
              railStyle={{ height: 8 }} // Thickness of the rail (unfilled part)
              handleStyle={{
                height: 24, // Height of the slider handle
                width: 24, // Width of the slider handle
                marginTop: -7, // Centers the handle with the track
                backgroundColor: "white", // Customize handle color
                borderColor: "var(--brand-primary)",
              }}
            />
          </div>
          {/* <input 
                        type="range" 
                        min="3" 
                        max="20" 
                        value={triggers} 
                        onChange={(e) => setTriggers(Number(e.target.value))} 
                    />
                    <span>{triggers}</span> */}
        </div>

        <div className="form-group !mb-16">
          <label className="text-lg !font-semibold">Accounts Targeted</label>
          <div className="mt-8">
            <Slider
              min={3}
              max={20}
              marks={marks}
              step={null}
              value={accounts}
              onChange={(newValue) => setAccounts(newValue)}
              trackStyle={{ height: 8 }} // Thickness of the track (filled part)
              railStyle={{ height: 8 }} // Thickness of the rail (unfilled part)
              handleStyle={{
                height: 24, // Height of the slider handle
                width: 24, // Width of the slider handle
                marginTop: -7, // Centers the handle with the track
                backgroundColor: "white", // Customize handle color
                borderColor: "var(--brand-primary)",
              }}
            />
          </div>
          {/* <input 
                        type="range" 
                        min="3" 
                        max="20" 
                        value={triggers} 
                        onChange={(e) => setTriggers(Number(e.target.value))} 
                    />
                    <span>{triggers}</span> */}
        </div>
      </div>

      <div className="pricing-summary !px-10 !py-8">
        <div className="text-2xl !font-semibold border-b-[1px] pb-4 border-solid border-gray-300">Organization</div>
        <div className="billing-options flex mt-6 gap-x-6">
            <div className="flex gap-x-2 !my-auto">
            <input
              className="!my-auto custom-radio"
              type="radio"
              value="monthly"
              checked={billingType === "monthly"}
              onChange={() => setBillingType("monthly")}
            />
          <label className="!text-lg !my-auto !font-normal">
            Monthly
          </label>
            </div>
            <div className="flex gap-x-2 !my-auto">
            <input
              className="!my-auto custom-radio"
              type="radio"
              value="yearly"
              checked={billingType === "yearly"}
              onChange={() => setBillingType("yearly")}
            />
          <label className="!text-lg !my-auto !font-normal">
          Annual
          </label>
            </div>
        </div>
        <div>(Save $100/month on annual billing)</div>

        <div className="plan-details">
          <p>
            Your Plan: <span>Starter</span>
          </p>
          <p>
            Subtotal: <span>${totalPrice}</span>
          </p>
          <p>
            <em>Your first month will be prorated</em>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SettingBillingCalculator;
